import script from "./VirtualKeyboardHost.vue?vue&type=script&setup=true&lang=ts"
export * from "./VirtualKeyboardHost.vue?vue&type=script&setup=true&lang=ts"

import "./VirtualKeyboardHost.vue?vue&type=style&index=0&id=593f3f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593f3f94"]])

export default __exports__